<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h1 class="text-primary">
            {{ $t('common.labels.manageTitle') }} {{ $t('app.labels.banners') }}
          </h1>
          <div class="row">
            <stats
              :url="`/crud/banner/stats`"
              :entity="'banner'"
              :statsNeedsRefresh.sync="statsNeedsRefresh"
            ></stats>
          </div>
          <ajax-table
            class="table-hover table-striped"
            :columns="table.columns"
            :entity="'banner'"
            :url="'/banner'"
            :tableNeedsRefresh.sync="tableNeedsRefresh"
            :rows="table.data"
            @edit="gotToEditPage"
            @view="gotToViewPage"
            :options="{ actions: actions }"
          ></ajax-table>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" id="formModal">
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          v-if="viewMode === 'edit' || viewMode === 'view'"
        >
          <form @submit.prevent="editItem()">
            <div class="modal-header bg-primary text-white">
              <h3 class="modal-title mt-0">{{ $t('common.buttons.edit') }}</h3>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" class="text-white">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <slot name="create-form">
                <fg-input
                  type="text"
                  :label="$t('common.field.location')"
                  :placeholder="$t('common.field.location')"
                  :disabled="true"
                  v-model="currentItem.location"
                ></fg-input>
                <div class="row">
                  <div class="col-md-6">
                    <img
                      v-if="currentItem.url"
                      style="max-width:100%;"
                      :src="currentItem.url"
                    />
                  </div>
                  <div class="col-md-6">
                    <upload-button
                      v-if="viewMode === 'edit'"
                      name="bannerUrl"
                      :options="{
                        upload: true,
                        targetUrl: 'picture/banner',
                        method: 'POST',
                        headers: {},
                        base64: false,
                        label: $t('common.buttons.choose'),
                        class: 'btn btn-info',
                      }"
                      @uploaded="uploadDone"
                    ></upload-button>
                  </div>
                </div>
              </slot>
            </div>
            <div class="modal-footer">
              <slot name="edit-modal-footer">
                <button
                  type="button"
                  class="btn btn-default btn-simple mr-auto"
                  @click="closeModal()"
                >
                  {{ $t('common.buttons.cancel') }}
                </button>
                <button
                  type="submit"
                  v-if="viewMode === 'edit'"
                  class="btn btn-primary ml-auto"
                >
                  {{ $t('common.buttons.save') }}
                </button>
                <button
                  type="button"
                  v-if="viewMode === 'view'"
                  class="btn btn-primary ml-auto"
                  @click="closeModal()"
                >
                  {{ $t('common.buttons.close') }}
                </button>
              </slot>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from 'sweetalert2/dist/sweetalert2.js';
import apiErrors from '@/mixins/api-errors';
import EventBus from '@/stores/event-bus';
import config from '@/config/index';

export default {
  components: {},
  data() {
    return {
      url: config.apiUrl.replace('/api', ''),
      viewMode: 'view',
      currentItem: {},
      tableNeedsRefresh: false,
      statsNeedsRefresh: false,
      actions: {
        edit: true,
        view: true,
        export: true,
      },
      table: {
        columns: [{ field: 'url', type: 'image' }, 'location'],
        data: [],
      },
    };
  },
  mixins: [apiErrors],
  created() {
    this.loadData();
    if (this.$route.params && this.$route.params.id) {
      this.$http
        .get(`banner/${this.$route.params.id}`)
        .then((res) => {
          if (this.$route.name === 'Edit') {
            this.editFunction(res.data.body);
          } else if (this.$route.name === 'View') {
            this.viewFunction(res.data.body);
          }
          this.$forceUpdate();
        })
        .catch(this.apiErrorCallback);
    }
  },
  mounted() {
    this.$modal = $('#formModal');
  },
  methods: {
    uploadDone(e) {
      this.currentItem.url = e.url;
      if (e && e.url) {
        this.currentItem.url = e.url;
      }
      if (e && e.body && e.body.url) {
        this.currentItem.url = e.body.url;
        this.currentItem.image = e.body.url;
      }
      this.editItem();
    },

    loadData() {
      this.$http
        .get('/banner')
        .then((res) => {
          if (res && res.data && res.data.body) {
            this.table.data = res.data.body;
          }

          this.tableNeedsRefresh = true;
          this.statsNeedsRefresh = true;
          this.$forceUpdate();
        })
        .catch(this.apiErrorCallback);
    },

    openModal() {
      this.$modal.modal('show');
    },

    closeModal() {
      this.$modal.modal('hide');
    },

    gotToEditPage(item) {
      this.$router.push({ path: `/app/banner/${item._id}/edit` });
      this.editFunction(item);
    },

    gotToViewPage(item) {
      this.$router.push(`/app/banner/${item._id}`);
      this.viewFunction(item);
    },

    editItem() {
      this.$http
        .put(`/banner/${this.currentItem._id}`, this.currentItem)
        .then((res) => {
          EventBus.$emit(`${this.name}:created`, res.data);
          swal({
            title: this.$t('common.messages.successfullyModified', {
              title: this.$t('app.labels.banners'),
            }),
            type: 'success',
          });
          this.tableNeedsRefresh = true;
          this.$forceUpdate();

          this.closeModal();
        })
        .catch(this.apiErrorCallback);
      return false;
    },

    editFunction(item) {
      this.viewMode = 'edit';
      this.currentItem = item;
      this.openModal();
    },

    viewFunction(item) {
      this.viewMode = 'view';
      this.currentItem = item;
      this.openModal();
    },
  },
};
</script>
<style></style>
